<div class="go-form__switch-toggle__container">
  <ng-container *ngTemplateOutlet="labelPosition === 'before' ? labelTemplate : null"></ng-container>

  <div
    class="go-form__switch-toggle"
    (click)="toggle()">
    <input
      [id]="_id"
      class="go-form__switch-toggle__input"
      [ngClass]="inputClasses"
      type="checkbox"
      [formControl]="control">
    <span
      class="go-form__switch-toggle__toggle"
      [ngClass]="{ 'go-form__switch-toggle__toggle--disabled': control.disabled }">
    </span>
  </div>

  <ng-container *ngTemplateOutlet="labelPosition === 'after' ? labelTemplate : null"></ng-container>
</div>

<go-hint
  *ngFor="let hint of hints"
  [message]="hint"
  [theme]="theme">
</go-hint>

<go-form-errors [control]="control" [theme]="theme"></go-form-errors>

<ng-template #labelTemplate>
  <label
    *ngIf="label"
    [attr.for]="_id"
    class="go-form__label go-form__label--inline go-form__switch-toggle__label"
    [ngClass]="{
      'go-form__label--dark': theme === 'dark',
      'go-form__switch-toggle__label--before': labelPosition === 'before',
      'go-form__switch-toggle__label--disabled': control.disabled
    }">
    {{ label }}
    <go-required-text [control]="control"></go-required-text>
  </label>
</ng-template>
